import { RoomStateEvent } from 'matrix-js-sdk/src/matrix';
import { useEffect, useState } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

// Returns a Set of lower-cased Matrix IDs for the joined members of the active workspace.
// NOTE: must be safe to call without a workspace — does not use requireWorkspaceId, so it
// never throws for personal users (returns an empty set).
const useWorkspaceMemberMatrixIds = (): Set<string> => {
  const { matrixClient } = useMatrixContext();
  const { workspaceId } = useWorkspacesContext();
  const [memberIds, setMemberIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!workspaceId) {
      setMemberIds(new Set());
      return;
    }

    const room = matrixClient.getRoom(workspaceId);
    if (!room) return;

    const loadMembers = () => {
      const ids = room.getJoinedMembers().map((member) => member.userId.toLowerCase());
      setMemberIds(new Set(ids));
    };

    loadMembers();
    room.on(RoomStateEvent.Members, loadMembers);

    return () => {
      room.off(RoomStateEvent.Members, loadMembers);
    };
  }, [matrixClient, workspaceId]);

  return memberIds;
};

export default useWorkspaceMemberMatrixIds;
